import Base from '../common/Base';
import { useEffect, useState } from 'react';
import { Card, Tab, Nav, Row, Col, Container } from 'react-bootstrap';
import Gstr1Table from './tables/Gstr1table';
import Gstr1Sidebar from './sidebar/Gstr1Sidebar';
import GstrUploadBills from './tables/GstrUploadBills';
import uploading_image from '../../assets/images/up-loading.png';
import { uploadFiles, clearMessages, handleSheetApproval, handleSheetApprovalManager } from '../../slices/forms/gstr1';
import { clearNotification } from '../../slices/notification';
import { useDispatch, useSelector } from 'react-redux';
import BillsSidebar from './sidebar/BillsSidebar';
import axiosInstance from '../../services/instance';
import ChatPopup from '../common/ChatPopup';
import ViewSheetSummary from './ViewSheetSummary';
import toast from "react-hot-toast";
import Loader from '../common/Loader';
import useCheckAuthorization from '../../hooks/checkAuthorization';
import { CRUD_PERMISSIONS } from '../../constants/staff';

const Gstr1 = () => {
  const [key, setKey] = useState('view_form');
  const dispatch = useDispatch();
  const changeTab = (k) => {
    setKey(k);
  };
  const [uploadedBills, setUplaodedBills] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sheetData, setSheetData] = useState(null);
  const [sheetSummaryData, setSheetSummaryData] = useState(null);
  const { uploadFilesSuccess, billsUploading, uploadFilesData, handleSheetApprovalState } = useSelector((state) => state.gstr);
  const { isNotificationRoute, notification } = useSelector((state) => state.notification);
  const { selectedMonth, selectedYear, selectedStartDate, selectedEndDate } = useSelector((state) => state.common);

  const isManager = useCheckAuthorization(CRUD_PERMISSIONS.sheet.client_manager_role);

  const uploadFileData = (files, section_type, notes) => {
    dispatch(uploadFiles({ start_date: selectedStartDate, end_date: selectedEndDate, files, section_type, notes }));
  };

  const handleSheetSubmit = (sheetId, status) => {
    setLoading(true);
    dispatch(handleSheetApproval({ start_date: selectedStartDate, end_date: selectedEndDate, approve: status, isManager, sheetId }));
  };
  const handleSheetSubmitManager = (sheetId, status) => {
    setLoading(true);
    dispatch(handleSheetApprovalManager({ start_date: selectedStartDate, end_date: selectedEndDate, approve: status, isManager, sheetId }));
  };

  const getUploadedBills = async () => {
    try {
      setLoading(true);
      const res = await axiosInstance.post('/api/v1/gstr/lists', {
        start_date: selectedStartDate,
        end_date: selectedEndDate,
        perPage: 10,
        page: 1
      });
      setUplaodedBills(res.data.data.list);
    } catch (error) {
      console.error('error', error);
    } finally {
      setLoading(false);
    }
  };

  const getSheet = async () => {
    try {
      setLoading(true);
      const res = await axiosInstance.post('/api/v1/gstr/view/sheet', {
        start_date: selectedStartDate,
        end_date: selectedEndDate,
      });
      if (res.data?.data)
        setSheetSummaryData(res.data?.data);
      if (res.data?.data?.sheet !== null) {
        setSheetData(res.data?.data?.sheet);
      } else {
        setSheetData(null);
      }


    } catch (error) {
      console.error('error', error);
    } finally {
      setLoading(false);
    }
  };
  const clearFormUpload = async () => {
    dispatch(clearMessages(true));
    await getUploadedBills();
  };

  if (uploadFilesSuccess) {
    clearFormUpload();
  }

  if (handleSheetApprovalState.success) {
    dispatch(clearMessages(true));
    getSheet();
  }
  if (handleSheetApprovalState.error) {
    dispatch(clearMessages(true));
    getSheet();
  }

  const handleDownloadZip = async (item) => {
    try {
      const promise = axiosInstance.post(
        `/api/v1/gstr/download/zip`,
        {
          note_id: item.id,
        }, {
        responseType: 'blob', // Important! Tells axios to handle the response as a blob
      }
      );
      const response = await toast.promise(promise, {
        loading: "Downloading...",
        success: <b>Downloaded!</b>,
        error: <b>Downloading Failed.</b>,
      });
      // Create a URL for the blob
      const url = window.URL.createObjectURL(new Blob([response.data]));

      // Create a link element
      const link = document.createElement('a');
      link.href = url;
      const fileName = item.notes.replace(/ /g, "_");
      link.setAttribute('download', `${fileName}.zip`); // Specify the filename

      // Append to the document and click the link to trigger download
      document.body.appendChild(link);
      link.click();

      // Cleanup
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("error", error);
    } finally {
    }
  }

  const handleDeleteBill = async (billId) => {
    try {
      setLoading(true);
      const promise = axiosInstance.post('/api/v1/gstr/delete/file', {
        file_id: billId,
      });
      const response = await toast.promise(promise, {
        loading: "Deleting...",
        success: <b>Deleted!</b>,
        error: <b>Deleting Failed.</b>,
      });
      getUploadedBills();


    } catch (error) {
      console.error('error', error);
    } finally {
      setLoading(false);
    }
  }

  //const { comments, summary } = useSelector((state) => state.gstr.excelData);
  useEffect(() => {
    if (key === 'sales_data' || key === 'purchase_data' || key === 'bank_statements' || key === 'expense_data' || key === 'financial_reports') {
      getUploadedBills();
    }
    if (key === 'view_form')
      getSheet();
  }, [key, selectedStartDate, selectedEndDate]);

  useEffect(() => {
    if (isNotificationRoute) {
      /*if(notification?.parameters?.selected_tab === 1){
        setKey('view_form');
      }else if(notification?.parameters?.selected_tab === 2){
        setKey('upload_bills');
      }*/
      dispatch(clearNotification());

    }
  }, [isNotificationRoute])

  function formatMonthYear(mmYYYY) {
    if (!mmYYYY) return '';
    const [mm, yyyy] = mmYYYY.split('-');
    // month is 0-based in Date()
    const date = new Date(Number(yyyy), Number(mm) - 1);
    return date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
  }

  return (
    <Base header="gstr" headerTitle={'Corporate Tax Return'}>
      <Container fluid>
        <Card>
          <Card.Body>
            <div style={{ display: 'flex', justifyContent: 'flex-end', margin: '10px' }}>
              <span
                style={{
                  backgroundColor: '#FFE5B4', // light orange
                  color: '#F37920',           // dark orange
                  padding: '4px 8px',
                  borderRadius: '4px',
                  fontWeight: '500',
                }}
              >
                {formatMonthYear(selectedStartDate)}
                &nbsp;–&nbsp;
                {formatMonthYear(selectedEndDate)}
              </span>
            </div>
            <Tab.Container id="left-tabs-example" activeKey={key} onSelect={changeTab}>
              <Nav variant="tabs" as="ul" className="pa-nav-tabs-1 gstr-tab">
                <Nav.Item as="li">
                  <Nav.Link eventKey="view_form">View Form</Nav.Link>
                </Nav.Item>
                <Nav.Item as="li">
                  <Nav.Link eventKey="sales_data">Sales Data</Nav.Link>
                </Nav.Item>
                <Nav.Item as="li">
                  <Nav.Link eventKey="purchase_data">Purchase Data</Nav.Link>
                </Nav.Item>
                <Nav.Item as="li">
                  <Nav.Link eventKey="bank_statements">Bank Statements</Nav.Link>
                </Nav.Item>
                <Nav.Item as="li">
                  <Nav.Link eventKey="expense_data">Expense Data</Nav.Link>
                </Nav.Item>
                <Nav.Item as="li">
                  <Nav.Link eventKey="financial_reports">Financial Reports</Nav.Link>
                </Nav.Item>
              </Nav>
              {loading ? (
                <div class="text-center">Loading...</div>
              ) : (

                <Tab.Content>
                  <Tab.Pane eventKey="view_form">
                    <Row style={{ maxHeight: '80vh', overflowY: 'auto' }}>
                      <Col xl={9}>
                        {!sheetData ? <h4 className="text-center mt-4">No Summary Uploaded For the period !</h4> : <ViewSheetSummary sheetSummaryData={sheetSummaryData} handleSheetSubmit={handleSheetSubmit} handleSheetSubmitManager={handleSheetSubmitManager} sheetType="gstr1" getSheet={getSheet} />}
                      </Col>
                      <Col xl={3}>
                        <Gstr1Sidebar activeTab={key} />
                      </Col>
                    </Row>
                  </Tab.Pane>
                  <Tab.Pane eventKey="sales_data">
                    <Row>
                      <Col xl={8}>
                        <Tab.Container defaultActiveKey="sales_data">
                          <Tab.Content>
                            {[
                              { key: 'sales_data', label: 'Sales Data', section: 1 },
                            ].map((tab) => (
                              <Tab.Pane eventKey={tab.key}>
                                <h4
                                  className="jl-heading mt-0 mb-10 inline card-title bold-font"
                                  id="Filechange">
                                  <span className="pa-upload-icon">
                                    <img src={uploading_image} alt="" />
                                  </span>
                                  {tab.label}
                                </h4>
                                {billsUploading ? <Loader content="Uploading File! Please wait. Do not refresh or press back button" /> : <GstrUploadBills
                                  handleUploadFile={(fileData, notes) =>
                                    uploadFileData(fileData, tab.section, notes)
                                  }
                                />}

                              </Tab.Pane>
                            ))}
                          </Tab.Content>
                        </Tab.Container>
                      </Col>
                      <Col xl={4}>
                        <BillsSidebar uploadedBills={uploadedBills} handleDownloadZip={handleDownloadZip} handleDeleteBill={handleDeleteBill} />
                      </Col>
                    </Row>
                  </Tab.Pane>

                  <Tab.Pane eventKey="purchase_data">
                    <Row>
                      <Col xl={8}>
                        <Tab.Container defaultActiveKey="purchase_data">
                          <Tab.Content>
                            {[
                              { key: 'purchase_data', label: 'Purchase Data', section: 2 },
                            ].map((tab) => (
                              <Tab.Pane eventKey={tab.key}>
                                <h4
                                  className="jl-heading mt-0 mb-10 inline card-title bold-font"
                                  id="Filechange">
                                  <span className="pa-upload-icon">
                                    <img src={uploading_image} alt="" />
                                  </span>
                                  {tab.label}
                                </h4>
                                {billsUploading ? <Loader content="Uploading File! Please wait. Do not refresh or press back button" /> : <GstrUploadBills
                                  handleUploadFile={(fileData, notes) =>
                                    uploadFileData(fileData, tab.section, notes)
                                  }
                                />}

                              </Tab.Pane>
                            ))}
                          </Tab.Content>
                        </Tab.Container>
                      </Col>
                      <Col xl={4}>
                        <BillsSidebar uploadedBills={uploadedBills} handleDownloadZip={handleDownloadZip} handleDeleteBill={handleDeleteBill} />
                      </Col>
                    </Row>
                  </Tab.Pane>

                  <Tab.Pane eventKey="bank_statements">
                    <Row>
                      <Col xl={8}>
                        <Tab.Container defaultActiveKey="bank_statements">
                          <Tab.Content>
                            {[
                              { key: 'bank_statements', label: 'Bank Statements', section: 3 },
                            ].map((tab) => (
                              <Tab.Pane eventKey={tab.key}>
                                <h4
                                  className="jl-heading mt-0 mb-10 inline card-title bold-font"
                                  id="Filechange">
                                  <span className="pa-upload-icon">
                                    <img src={uploading_image} alt="" />
                                  </span>
                                  {tab.label}
                                </h4>
                                {billsUploading ? <Loader content="Uploading File! Please wait. Do not refresh or press back button" /> : <GstrUploadBills
                                  handleUploadFile={(fileData, notes) =>
                                    uploadFileData(fileData, tab.section, notes)
                                  }
                                />}

                              </Tab.Pane>
                            ))}
                          </Tab.Content>
                        </Tab.Container>
                      </Col>
                      <Col xl={4}>
                        <BillsSidebar uploadedBills={uploadedBills} handleDownloadZip={handleDownloadZip} handleDeleteBill={handleDeleteBill} />
                      </Col>
                    </Row>
                  </Tab.Pane>

                  <Tab.Pane eventKey="expense_data">
                    <Row>
                      <Col xl={8}>
                        <Tab.Container defaultActiveKey="expense_data">
                          <Tab.Content>
                            {[
                              { key: 'expense_data', label: 'Expense Data', section: 4 },
                            ].map((tab) => (
                              <Tab.Pane eventKey={tab.key}>
                                <h4
                                  className="jl-heading mt-0 mb-10 inline card-title bold-font"
                                  id="Filechange">
                                  <span className="pa-upload-icon">
                                    <img src={uploading_image} alt="" />
                                  </span>
                                  {tab.label}
                                </h4>
                                {billsUploading ? <Loader content="Uploading File! Please wait. Do not refresh or press back button" /> : <GstrUploadBills
                                  handleUploadFile={(fileData, notes) =>
                                    uploadFileData(fileData, tab.section, notes)
                                  }
                                />}

                              </Tab.Pane>
                            ))}
                          </Tab.Content>
                        </Tab.Container>
                      </Col>
                      <Col xl={4}>
                        <BillsSidebar uploadedBills={uploadedBills} handleDownloadZip={handleDownloadZip} handleDeleteBill={handleDeleteBill} />
                      </Col>
                    </Row>
                  </Tab.Pane>

                  <Tab.Pane eventKey="financial_reports">
                    <Row>
                      <Col xl={8}>
                        <Tab.Container defaultActiveKey="financial_reports">
                          <Tab.Content>
                            {[
                              { key: 'financial_reports', label: 'Financial Reports', section: 5 },
                            ].map((tab) => (
                              <Tab.Pane eventKey={tab.key}>
                                <h4
                                  className="jl-heading mt-0 mb-10 inline card-title bold-font"
                                  id="Filechange">
                                  <span className="pa-upload-icon">
                                    <img src={uploading_image} alt="" />
                                  </span>
                                  {tab.label}
                                </h4>
                                {billsUploading ? <Loader content="Uploading File! Please wait. Do not refresh or press back button" /> : <GstrUploadBills
                                  handleUploadFile={(fileData, notes) =>
                                    uploadFileData(fileData, tab.section, notes)
                                  }
                                />}

                              </Tab.Pane>
                            ))}
                          </Tab.Content>
                        </Tab.Container>
                      </Col>
                      <Col xl={4}>
                        <BillsSidebar uploadedBills={uploadedBills} handleDownloadZip={handleDownloadZip} handleDeleteBill={handleDeleteBill} />
                      </Col>
                    </Row>
                  </Tab.Pane>
                </Tab.Content>
              )}
            </Tab.Container>
          </Card.Body>
        </Card>
        <ChatPopup chat_type="GSTR1" />
      </Container>
    </Base>
  );
};
export default Gstr1;
